import { toast } from "react-toastify";

const initState = {
  timeslots: [],
  destinations: [],
  carmodels: [],
  adschedules: new Map(),
  scheduleslist: null,
  routeaverages: new Map(),
  adscheduleloading: false,
  routeaverageloading: false,
  timeslotsloading: false,
  destinationsloading: false,
  carmodelsloading: false,
  loading: false,
  regions: [],
  vregions: [],
};

const regionReducer = (state = initState, action) => {
  switch (action.type) {
    case "LOAD_TIMESLOTS":
      return {
        ...state,
        timeslotsloading: true,
      };
    case "LOAD_DESTINATIONS":
      return {
        ...state,
        destinationsloading: true,
      };
    case "LOAD_CARMODELS":
      return {
        ...state,
        carmodelsloading: true,
      };
    case "GET_TIMESLOTS":
      return {
        ...state,
        timeslots: action.payload,
        loading: false,
        timeslotsloading: false,
      };
    case "GET_TIMESLOTS_ERROR":
      console.log(action.payload);
      toast.error("Please Refresh the Page");
      return {
        ...state,
        loading: false,
        timeslotsloading: false,
      };
    case "GET_DESTINATIONS":
      return {
        ...state,
        destinations: action.payload,
        loading: false,
        destinationsloading: false,
      };
    case "GET_DESTINATIONS_ERROR":
      console.log(action.payload);
      toast.error("Please Refresh the Page");
      return {
        ...state,
        loading: false,
        destinationsloading: false,
      };
    case "GET_CARMODELS":
      return {
        ...state,
        carmodels: action.payload,
        loading: false,
        carmodelsloading: false,
      };
    case "GET_CARMODELS_ERROR":
      console.log(action.payload);
      toast.error("Please Refresh the Page");
      return {
        ...state,
        loading: false,
        carmodelsloading: false,
      };
    case "GET_REGIONS_FOR_BUSINESS":
      return {
        ...state,
        loading: false,
        regions: action.payload,
      };
    case "GET_REGIONS_FOR_BUSINESS_ERROR":
      console.log(action.payload);
      toast.error("Please Refresh the Page");
      return {
        ...state,
        regions: [],
        loading: true,
      };
    case "GET_REGIONS_FOR_VEHICLE":
      return {
        ...state,
        loading: false,
        vregions: action.payload,
      };
    case "GET_REGIONS_FOR_VEHICLE_ERROR":
      console.log(action.payload);
      toast.error("Please Refresh the Page");
      return {
        ...state,
        vregions: [],
        loading: false,
      };

    case "GET_AD_SCHEDULES":
      const schMap = new Map();
      const schList = [];
      var tempschedules = {};
      action.payload.adSchedules.forEach((sche) => {
        tempschedules = { ...sche.adSchedules, ...tempschedules };
      });
      var temparray = Array.from(Object.values(tempschedules)).sort((a, b) =>
        a.date.toDate() > b.date.toDate() ? 1 : -1
      );

      const allowedday = new Date(
        new Date().setDate(
          new Date().getDate() + action.payload.extraStartDays - 1
        )
      );
      allowedday.setHours(0, 0, 0);
      const maxday = new Date(
        new Date().setDate(allowedday.getDate() + action.payload.roughEstimate)
      );
      maxday.setHours(0, 0, 0);

      for (let index = 0; index < temparray.length; index++) {
        const obj = temparray[index];
        const date = new Date(obj.date.toDate().setHours(0, 0, 0));
        schList.push(
          {
            date: date,
            cm: obj.cm,
            ts: obj.ts,
            sp: obj.sp,
            aastd: obj.aastd,
            aalst: obj.aalst,
          }
          // new AdSchedule(date, obj.cm, obj.ts, obj.sp, obj.aastd, obj.aalst)
        );

        if (date > allowedday) {
          if (date <= maxday) {
            const datestring = date.toDateString();
            //console.log(datestring);
            if (schMap.has(datestring)) {
              const temp = schMap.get(datestring);
              if (temp.keys === null) {
                temp.keys = Object.fromEntries(state.routeaverages);
                delete temp.keys[Array.from(temp.combs.keys())[0]];
              }
              temp.totalspot += obj.aastd + obj.aalst;
              temp.totalaastd += obj.aastd;
              temp.combs.set(obj.sp + "___" + obj.ts + "___" + obj.cm, obj);
              delete temp.keys[obj.sp + "___" + obj.ts + "___" + obj.cm];
              schMap.set(datestring, temp);
            } else {
              const tmp = new Map();
              tmp.set(obj.sp + "___" + obj.ts + "___" + obj.cm, obj);
              schMap.set(datestring, {
                keys: null,
                combs: tmp,
                totalspot: obj.aastd + obj.aalst,
                totalaastd: obj.aastd,
              });
            }
            if (index + 1 < temparray.length) {
            }
            if (schMap.get(datestring).combs.size < state.routeaverages.size) {
              if (index + 1 < temparray.length) {
                if (
                  datestring !==
                  new Date(
                    temparray[index + 1].date.toDate().setHours(0, 0, 0)
                  ).toDateString()
                ) {
                  for (const key in schMap.get(datestring).keys) {
                    const temp = schMap.get(datestring);
                    temp.totalspot += schMap.get(datestring).keys[key].scstpd;
                    temp.combs.set(key, {
                      aalst: schMap.get(datestring).keys[key].scstpd,
                      aastd: 0,
                    });

                    schMap.set(datestring, temp);
                  }

                  const temp = schMap.get(datestring);
                  temp.keys = null;
                  schMap.set(datestring, temp);
                }
              } else {
                for (const key in schMap.get(datestring).keys) {
                  const temp = schMap.get(datestring);
                  temp.totalspot += schMap.get(datestring).keys[key].scstpd;
                  temp.combs.set(key, {
                    aastd: schMap.get(datestring).keys[key].scstpd,
                    aalst: 0,
                  });
                  schMap.set(datestring, temp);
                }

                const temp = schMap.get(datestring);
                temp.keys = null;
                schMap.set(datestring, temp);
                //dasfa
              }
            }
          } else {
            break;
          }
        }
      }
      // console.log("FINAL ADSCH");
      // console.log(schMap);
      // console.log(schList);
      return {
        ...state,
        adscheduleloading: false,
        adschedules: schMap,
        scheduleslist: tempschedules,
      };
    case "GET_AD_SCHEDULES_ERROR":
      console.log(action.payload);
      toast.error("Please Refresh the Page");
      return {
        ...state,
        adschedules: new Map(),
        scheduleslist: null,
        adscheduleloading: false,
      };

    case "GET_ROUTE_AVERAGES":
      const temproutes = new Map();
      action.payload.forEach((r) => {
        r.routeAverages.forEach((rav) => {
          temproutes.set(rav.sp + "___" + rav.ts + "___" + rav.cm, rav);
        });
      });
      return {
        ...state,
        routeaverageloading: false,
        routeaverages: temproutes,
      };
    case "GET_ROUTE_AVERAGES_ERROR":
      console.log(action.payload);
      toast.error("Please Refresh the Page");
      return {
        ...state,
        routeaverages: [],
        routeaverageloading: false,
      };

    case "LOADING_REGIONS":
      return {
        ...state,
        loading: true,
      };
    case "LOADING_ROUTEAVERAGE":
      return {
        ...state,
        routeaverageloading: true,
      };
    case "LOADING_ADSCHEDULE":
      return {
        ...state,
        adscheduleloading: true,
      };
    default:
      return state;
  }
};

export default regionReducer;
